import {appHistory} from '../../../history';
import type {NotificationOptions} from '../../../notifications/index';

export type WidgetCounts = {
    tasks?: string;
    activities?: string;
    relatedContacts?: string;
    relatedAccounts?: string;
};

export function getWidgetTabCount(type: string, counts: WidgetCounts): string | undefined {
    if (type === 'TASKS') {
        return counts.tasks;
    }
    if (type === 'ACTIVITIES') {
        return counts.activities;
    }
    if (type === 'RELATED_CONTACTS') {
        return counts.relatedContacts;
    }
    if (type === 'RELATED_ACCOUNTS') {
        return counts.relatedAccounts;
    }

    return undefined;
}

export function getTimelineItemNotificationArgs(
    contentType: 'ACTIVITY' | 'NOTE',
    id: string,
    entityDisplayName: string,
    activityTypeName?: string,
    noteBody?: string
): {title: string; options: NotificationOptions} {
    const hash = contentType === 'NOTE' ? `/note/${parseInt(id)}` : `/${id}`;
    const body =
        contentType === 'ACTIVITY'
            ? `${activityTypeName ?? 'Activity'} logged${
                  entityDisplayName ? ` with ${entityDisplayName}` : ''
              }`
            : noteBody;

    return {
        title:
            contentType === 'ACTIVITY'
                ? 'Activity saved'
                : `Note saved${entityDisplayName ? ` on ${entityDisplayName}` : ''}`,
        options: {
            icon: 'check',
            body,
            onClick: () => appHistory.replace({...appHistory.location, hash}),
        },
    };
}
